import * as React from "react"
import * as Antd from "antd"

import styles from "./ConversationAiControlRow.module.scss"
import AppText from "@components/general/AppText/AppText.tsx"

export interface IConversationAiControlRowProps {
	labelKey: string
	isLoading: boolean
	isSaving: boolean
	isEnabled: boolean
	isDisabled?: boolean
	showSwitch?: boolean
	onToggle: (nextValue: boolean) => void
}

const ConversationAiControlRow: React.FC<IConversationAiControlRowProps> = ({
	labelKey,
	isLoading,
	isSaving,
	isEnabled,
	isDisabled = false,
	showSwitch = true,
	onToggle,
}) => {
	const isSwitchLoading = isLoading || isSaving

	return (
		<div className={styles.ai_control_row}>
			<div className={styles.ai_control_text}>
				<AppText
					className={styles.ai_control_label}
					textKey={labelKey}
				/>
			</div>

			<div className={styles.ai_control_actions}>
				{showSwitch && (
					<Antd.Switch
						checked={isEnabled}
						disabled={isSaving || isDisabled}
						loading={isSwitchLoading}
						onChange={onToggle}
					/>
				)}
			</div>
		</div>
	)
}

export default React.memo(ConversationAiControlRow)
